import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Badge } from 'antd';
import { HomeOutlined, DatabaseOutlined, BellOutlined, UserOutlined } from '@ant-design/icons';
import api from '../api';
import { H5_TAB_BAR_PX } from '../h5Layout';

const tabs = [
  { key: '/', label: '首页', icon: <HomeOutlined /> },
  { key: '/assets', label: '资产', icon: <DatabaseOutlined /> },
  { key: '/messages', label: '消息', icon: <BellOutlined /> },
  { key: '/profile', label: '我的', icon: <UserOutlined /> },
];

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    api.get('/messages/unread-count').then(res => {
      setUnread(res?.count || 0);
    }).catch(() => {});
  }, [location.pathname]);

  const activeKey = tabs.find(t => t.key !== '/' && location.pathname.startsWith(t.key))?.key || '/';

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      <div style={{ paddingBottom: H5_TAB_BAR_PX }}>
        <Outlet />
      </div>
      {/* Bottom tab bar */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: '#fff',
        borderTop: '1px solid #eee',
        display: 'flex',
        height: H5_TAB_BAR_PX,
      }}>
        {tabs.map(tab => {
          const isActive = activeKey === tab.key;
          const color = isActive ? '#1677FF' : '#999';
          const iconEl = React.cloneElement(tab.icon, { style: { fontSize: 24, color } });

          return (
            <div
              key={tab.key}
              onClick={() => {
                if (tab.key === '/assets') {
                  // 底栏「资产」进入普通列表，避免沿用申请处置/已处置等特殊筛选
                  if (location.pathname === '/assets' && !location.search) {
                    return;
                  }
                  navigate('/assets');
                  return;
                }
                navigate(tab.key);
              }}
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color,
                fontSize: 11,
                gap: 2,
              }}
            >
              {tab.key === '/messages' ? (
                <Badge count={unread} size="small" offset={[2, 0]}>
                  {iconEl}
                </Badge>
              ) : iconEl}
              <span>{tab.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
